import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Eye, X } from 'lucide-react';
import '../../../../assets/css/admin/dashboardCSS/notificationDropdown.css';

const NotificationDropdown = ({ isOpen, onClose }) => {
  const dropdownRef = useRef(null);
  
  // Sample notifications - just for dropdown preview
  const [notifications] = useState([
    {
      id: 1,
      type: 'request',
      icon: '📚',
      message: 'New help request from Ali Khan',
      time: '2 minutes ago',
      isRead: false,
    },
    {
      id: 2,
      type: 'donation',
      icon: '💰',
      message: 'Ahmed Donor donated PKR 50,000',
      time: '15 minutes ago',
      isRead: false,
    },
    {
      id: 3,
      type: 'dispute',
      icon: '⚠️',
      message: 'New dispute raised by Usman Donor',
      time: '1 hour ago',
      isRead: true,
    }
  ]);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="notification-dropdown" ref={dropdownRef}>
      {/* Header */}
      <div className="notification-dropdown-header">
        <h4 className="notification-dropdown-title">Notifications</h4>
        {unreadCount > 0 && (
          <span className="notification-dropdown-badge">{unreadCount}</span>
        )}
        <button className="notification-close-btn" onClick={onClose}>
          <X size={18} />
        </button>
      </div>

      {/* Notifications List */}
      <div className="notification-dropdown-list">
        {notifications.slice(0, 3).map((notification) => (
          <div
            key={notification.id}
            className={`notification-dropdown-item ${!notification.isRead ? 'unread' : ''}`}
          >
            <div className="notification-dropdown-icon">{notification.icon}</div>
            <div className="notification-dropdown-content">
              <p className="notification-dropdown-message">{notification.message}</p>
              <span className="notification-dropdown-time">{notification.time}</span>
            </div>
            {!notification.isRead && <span className="notification-dropdown-dot"></span>}
          </div>
        ))}
      </div>

      {/* Footer - View All Button */}
      <div className="notification-dropdown-footer">
        <Link 
          to="/Admin/Notifications" 
          className="notification-view-all-btn"
          onClick={onClose}
        >
          <Eye size={18} />
          View All Notifications
        </Link>
      </div>
    </div>
  );
};

export default NotificationDropdown;